import React, { useState } from 'react';
import { object, string } from 'yup';
import {
  Formik,
  Form,
} from 'formik';
import { FontAwesomeIcon as FA } from '@fortawesome/react-fontawesome';
import { faDoorOpen } from '@fortawesome/free-solid-svg-icons/faDoorOpen';
import { faEye } from '@fortawesome/free-regular-svg-icons/faEye';
import { faEyeSlash } from '@fortawesome/free-regular-svg-icons/faEyeSlash';

import { useHttpStatus } from '~/commons/hooks';

import FormGroup from '~/commons/components/FormGroup.jsx';
import FormHttpAlert from '~/commons/components/FormHttpAlert.jsx';
import FormHttpBtn from '~/commons/components/FormHttpBtn.jsx';
import LinkPwdReset from './LinkPwdReset.jsx';
import ModalConfirmLogin from './ModalConfirmLogin.jsx';

const schema = object().shape({
  username: string()
    .trim()
    .lowercase()
    .required('必填'),
  password: string()
    .required('必填'),
});
const defaults = {
  username: '',
  password: '',
};

const FormLogin = ({
  title = '',
}) => {
  const [showPwd, setShowPwd] = useState(false);
  const [confirmModal, setConfirmModal] = useState(false);
  const [loginRes, loginReq] = useHttpStatus({
    onSuccess({ data }) {
      if (data.allowed !== undefined) {
        setConfirmModal(true);
      } else {
        window.location.replace('admin');
      }
    },
  });

  const login = (values) => loginReq({
    method: 'post',
    url: 'api/core/auth',
    data: {
      ...values,
      web: 1,
      base: window.location.pathname,
    },
  });

  return (
    <>
      <div className="row mb-3">
        <div className="col">{title}</div>
      </div>
      <Formik
        validationSchema={schema}
        initialValues={defaults}
        onSubmit={(values) => login(values)}
      >
        <Form>
          {/* confirm login modal */}
          <ModalConfirmLogin
            show={confirmModal}
            onHide={() => setConfirmModal(false)}
            allow={loginRes?.payload}
          />

          {/* form content */}
          <FormHttpAlert res={loginRes} />
          <FormGroup
            name="username"
            label={null}
            placeholder="帳戶"
          />
          <FormGroup
            name="password"
            type={showPwd ? 'text' : 'password'}
            label={null}
            placeholder="密碼"
            append={(
              <button
                type="button"
                className="btn pwd-visibility"
                onClick={() => setShowPwd(!showPwd)}
              >
                <FA icon={showPwd ? faEyeSlash : faEye} />
              </button>
            )}
          />
          <div className="row mb-3">
            <div className="col"></div>
            <div className="col-auto">
              <LinkPwdReset />
            </div>
          </div>
          <div className="form-group text-right">
            <FormHttpBtn
              res={loginRes}
              type="submit"
              className="btn-primary btn-block"
              icon={faDoorOpen}
            >
              登入
            </FormHttpBtn>
          </div>
        </Form>
      </Formik>
    </>
  );
};

export default FormLogin;
